import type { FormModuleComponent as FormModuleComponentType } from 'services/content/components/types/FormModule'
import Content from './Content'
import Field from './Field'
import Radio from './Radio'

type Props = {
  className?: string
  component: FormModuleComponentType
  values: Record<string, string>
  onChange: (name: string, value: string) => void
}

function FormModuleComponent({
  className,
  component,
  values,
  onChange,
}: Props) {
  switch (component.name) {
    case 'TextBlock':
    case 'SectionHeadline':
      return <Content component={component} />

    default: {
      const { fieldId } = component.props

      const handleChange = (value: string) => {
        onChange(fieldId, value)
      }

      switch (component.name) {
        case 'Radio':
          return (
            <Radio
              component={component}
              onChange={handleChange}
              value={values[fieldId]}
            />
          )
        default:
          return (
            <Field
              className={className}
              component={component}
              onChange={handleChange}
              value={values[fieldId]}
            />
          )
      }
    }
  }
}

export default FormModuleComponent
